import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SpeechIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 26.286 24.303"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 22.5)}
      {...svgProps}
    >
      <g
        fill={svgProps.fill ?? "none"}
        stroke={color ?? svgProps.stroke ?? "currentColor"}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <g transform="translate(.286)">
          <path d="M16.25 15.75v3.75l4.5-3.75h3a1.5 1.5 0 001.5-1.5v-12a1.5 1.5 0 00-1.5-1.5h-12a1.5 1.5 0 00-1.5 1.5" />
          <circle cx="6" cy="12" r="5.25" />
          <path d="M13.675 23.25A9.721 9.721 0 00.75 21.042" />
        </g>

        <path
          strokeWidth="1.3"
          d="M15.952 11.535a.638.638 0 01-.893-.335.812.812 0 01-.07-.329V5.878a.705.705 0 01.666-.737.622.622 0 01.3.077l4.495 2.5a.778.778 0 01.3.99.7.7 0 01-.3.329z"
        />
      </g>
    </SVG>
  );
};
